import { loadItem, storageKeys } from "../../shared/storage/index";

/** True when the account already finished onboarding (server profile or cached state). */
export function isAccountOnboardingComplete(user = null, profile = null) {
  if (user?.onboardingComplete) return true;
  if (profile?.onboardingComplete) return true;

  const username = String(profile?.username || user?.username || "").trim();
  const photos = Array.isArray(profile?.photos) ? profile.photos : [];
  const hasPhotos = (profile?.photoCount > 0) || photos.length > 0;
  const hasCity = Boolean(String(profile?.city || "").trim());
  const hasAge = profile?.age != null && profile?.age !== "";

  if (username && hasPhotos && hasCity && hasAge) return true;

  if (loadItem(storageKeys.onboardingComplete)) return true;

  const cachedProfile = loadItem(storageKeys.profile);
  if (cachedProfile?.onboardingComplete) return true;
  if (cachedProfile?.username && Array.isArray(cachedProfile?.photos) && cachedProfile.photos.length) {
    return true;
  }

  return false;
}

/** Server flag for routing: true = done, false = needs onboarding, null = unknown (keep local). */
export function resolveOnboardingCompleteFromAuth(user = null, profile = null) {
  if (isAccountOnboardingComplete(user, profile)) return true;
  if (profile === null && user && user.onboardingComplete === false) return false;
  if (profile && !isAccountOnboardingComplete(user, profile)) return false;
  return null;
}
